const investmentActionLang = {
	explore: {
		tag: 'investment.action.explore',
		fr: 'Voir',
		en: 'Explore',
	},
	export_data: {
		tag: 'investment.action.export_data',
		fr: 'Exporter les données',
		en: 'Export data',
	},
	position: {
		tag: 'investment.action.position',
		fr: 'Position',
		en: 'Position',
	},
	share_link: {
		tag: 'investment.action.share_link',
		fr: 'Partager cette page',
		en: 'Share this page',
	},
	share_link_short: {
		tag: 'investment.action.share_link_short',
		fr: 'Partager',
		en: 'Share page',
	},
	copy_to_clipboard: {
		tag: 'investment.action.copy_to_clipboard',
		fr: 'Copier dans le presse papier',
		en: 'Copy to clipboard',
	},
	copy_to_clipboard_success: {
		tag: 'investment.action.copy_to_clipboard_success',
		fr: 'Le lien de cette page est copié dans votre presse papier !',
		en: 'This page link is copied in your clipboard !',
	},
	switch_subportfolio: {
		tag: 'investment.action.switch_subportfolio',
		fr: 'Cantons',
		en: 'Sub portfolios',
	},
	switch_fund: {
		tag: 'investment.action.switch_fund',
		fr: 'Fonds',
		en: 'Funds',
	},
	switch_currency_x_fund: {
		tag: 'investment.action.switch_currency_x_fund',
		fr: '{{currency}} fonds ({{count}})',
		en: '{{currency}} funds ({{count}})',
		plurals: {
			zero: {
				fr: 'Aucun fonds',
				en: 'No fund',
			},
			one: {
				fr: '{{currency}} fonds ({{count}})',
				en: '{{currency}} fund ({{count}})',
			},
			other: {
				fr: '{{currency}} fonds ({{count}})',
				en: '{{currency}} funds ({{count}})',
			},
		},
	},
	switch_currency_x_fund_mobile: {
		tag: 'investment.action.switch_currency_x_fund_mobile',
		fr: '{{currency}} ({{count}})',
		en: '{{currency}} ({{count}})',
		plurals: {
			zero: {
				fr: 'Aucun fonds',
				en: 'No fund',
			},
			one: {
				fr: '{{currency}} ({{count}})',
				en: '{{currency}} ({{count}})',
			},
			other: {
				fr: '{{currency}} ({{count}})',
				en: '{{currency}} ({{count}})',
			},
		},
	},
};

export default investmentActionLang;
